module.exports = __webpack_public_path__ + "static/cookies-ff51388a0508be12e0bc53bd5e0ab2fc.png";